import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // This runs on fresh page load AND when element is added via Turbo
    this.scrollToBottom() // Scrolls to bottom immediately

    // This watches for future changes (new comments added)
    this.observer = new MutationObserver(() => {
      this.scrollToBottom()
    })
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  scrollToBottom() {
    this.element.scrollTop = this.element.scrollHeight
  }
}
